import { render, staticRenderFns } from "./HeroSection.vue?vue&type=template&id=ffec851c&scoped=true&"
import script from "./HeroSection.vue?vue&type=script&lang=js&"
export * from "./HeroSection.vue?vue&type=script&lang=js&"
import style0 from "./HeroSection.vue?vue&type=style&index=0&id=ffec851c&prod&lang=scss&scoped=true&"
import style1 from "./HeroSection.vue?vue&type=style&index=1&id=ffec851c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffec851c",
  null
  
)

export default component.exports